/** Avoid a blanket delivery promise when tariffs and times vary by destination. */
export function seoDescription(value: string): string {
  return value.replace(/Env[ií]os?[^.!?]{0,70}24\s*[-–]\s*48\s*h(?:oras)?[^.!?]*/gi, 'Consulta plazos y gastos según destino');
}
